import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export type HttpErrorKind = 'connection' | 'session-expired' | 'validation' | 'server' | 'unknown';

const SESSION_EXPIRED_STATUSES: readonly number[] = [HttpStatusCode.Unauthorized, HttpStatusCode.Gone];

/** Status 0: el navegador no llegó al servidor (sin red, CORS, servidor caído). */
export function isConnectionError(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === 0;
}

/** 401 o 410: el token venció o fue revocado. */
export function isSessionExpired(error: unknown): boolean {
  return error instanceof HttpErrorResponse && SESSION_EXPIRED_STATUSES.includes(error.status);
}

/** Fallas que podrían resolverse solas: sin conexión o error del servidor (5xx). */
export function isTransientError(error: unknown): boolean {
  return error instanceof HttpErrorResponse && (error.status === 0 || error.status >= 500);
}

/** Agrupa un error en una categoría. `validation` cubre el resto de los 4xx. */
export function classifyHttpError(error: unknown): HttpErrorKind {
  if (!(error instanceof HttpErrorResponse)) return 'unknown';
  if (isConnectionError(error)) return 'connection';
  if (isSessionExpired(error)) return 'session-expired';
  if (error.status >= 500) return 'server';
  if (error.status >= 400) return 'validation';
  return 'unknown';
}
